import { Component, State, Vue } from 'nuxt-property-decorator'

@Component
export default class ExperienceGa extends Vue {
  @State klook!: Data.Klook

  getCustomDimension(frontendId?: number | string, countryId?: number | string, cityId?: number | string) {
    let type = 'all'
    if (cityId) {
      type = `city_${cityId}`
    } else if (countryId) {
      type = `country_${countryId}`
    }

    return {
      script: [
        this.$insetDataLayer({
          'Destination Type': type,
          'Category ID': `category_${frontendId}`
        })
      ]
    }
  }
}
